import * as constants from 'appConstants';

export const SURFACE_403_ACTIONS = {
  [constants.INVITE_VALIDATION.TRIGGER]: true
};
